export const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
export const getBannerActions = placement => placement?.audience === 'neuroweb'
  ? [{ value: '', label: 'Sin botón' }, { value: '#turnos', label: 'Consultar por un turno' }, { value: '#servicios', label: 'Ver estudios disponibles' }, { value: '#centro', label: 'Conocer nuestros centros' }]
  : [{ value: '', label: 'Sin botón' }, { value: '/faq', label: 'Preguntas frecuentes' }, { value: 'https://wa.me/5491155291681', label: 'Contactar por WhatsApp' }];
const isEmptyDescription = (html = '') =>
  String(html || '').replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '').replace(/\s/g, '') === '';
const isSafeHref = href => /^(https?:\/\/|\/(?!\/)|#)/i.test(href || '');
export function readBannerContent(html = '') {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script, style, iframe').forEach(node => node.remove());
  let buttonNode = doc.querySelector('p[data-cms-action]');
  if (!buttonNode) {
    const legacyLinks = [...doc.querySelectorAll('a')].filter(a => {
      const p = a.parentElement;
      return p && p.tagName === 'P' && p.children.length === 1 && p.textContent.trim() === a.textContent.trim();
    });
    buttonNode = legacyLinks.length ? legacyLinks[legacyLinks.length - 1].parentElement : null;
  }
  let action = '';
  let buttonText = '';
  if (buttonNode) {
    const link = buttonNode.querySelector('a');
    const href = link?.getAttribute('href') || '';
    if (link && isSafeHref(href)) {
      action = href;
      buttonText = link.textContent.trim();
      buttonNode.remove();
    }
  }
  return { description: doc.body.innerHTML.trim(), action, buttonText };
}
export function buildBannerHtml(descriptionHtml = '', action = '', buttonText = '') {
  const desc = isEmptyDescription(descriptionHtml) ? '' : String(descriptionHtml);
  const btn = action && buttonText.trim()
    ? `<p data-cms-action><a href="${escapeHtml(action)}">${escapeHtml(buttonText.trim())}</a></p>`
    : '';
  return desc + btn;
}
